/** Stable TanStack Query identity dimensions for tutor reads (tenant + student). */
export function resolveTutorQueryIdentity(opts: {
  studentId?: string | null;
  tenantId?: string | null;
}): { membershipKey: string; studentKey: string } {
  const tenantId = (opts.tenantId ?? '').trim() || (
    typeof localStorage !== 'undefined' ? (localStorage.getItem('X_TENANT_ID') || '').trim() : ''
  );
  const studentKey = (opts.studentId || '').trim() || 'anonymous';
  const membershipKey = tenantId || 'no-tenant';
  return { membershipKey, studentKey };
}

/** Roster student id only — never the authenticated platform user id. */
export function resolveRosterStudentId(student: {
  id?: string | null;
  platform_user_id?: string | null;
  student?: { id?: string | null };
} | null | undefined): string | null {
  const nested = student?.student?.id;
  const raw = student?.id || student?.platform_user_id || nested || null;
  const trimmed = String(raw || '').trim();
  return trimmed || null;
}

export function isTutorQueryIdentityReady(membershipKey: string, studentKey: string): boolean {
  return membershipKey !== 'no-tenant' && studentKey !== 'anonymous';
}
